// @flow
import React from 'react';
import type {
  Node,
} from 'react';
import {
  ScrollSync,
} from 'react-virtualized';

import {
  scrollbarSize,
} from 'chronos-utils';
import VirtualList from '../VirtualList/VirtualList';
import VirtualGrid from '../VirtualGrid/VirtualGrid';

import {
  Grid,
  GridLeft,
  GridLeftHeader,
  GridLeftBody,
  GridLeftFooter,
  GridRight,
  GridRightHeader,
  GridRightBody,
  GridRightFooter,
} from './styled';

type SubProps = {
  headerHeight?: number,
  headerCellRenderer?: Node,
  footerCellRenderer?: Node,
};

type Props = {
  listProps?: SubProps,
  gridProps?: SubProps,
  fetching?: boolean,
  listWidth: number,
  listResizeRequest: Function,
};

// TODO needs refactoring!
const GridList = (props: Props) => (
  <ScrollSync>
    {({ onScroll, scrollTop, scrollLeft }) => (
      <Grid>
        <GridLeft
          defaultSize={{
            width: props.listWidth,
          }}
          minWidth={200}
          enable={{
            top: false,
            right: true,
            bottom: false,
            left: false,
            topRight: false,
            bottomRight: false,
            bottomLeft: false,
            topLeft: false,
          }}
          onResizeStop={(e) => {
            props.listResizeRequest(e.clientX);
          }}
        >
          <GridLeftHeader style={{ height: props.listProps.headerHeight }}>
            <VirtualGrid
              {...props.listProps}
              rowCount={1}
              columnCount={1}
              cellRenderer={props.listProps.headerCellRenderer}
              width={props.listWidth}
              height={props.listProps.headerHeight}
              columnWidth={props.listWidth}
              style={{ background: '#f9f9f9' }}
            />
          </GridLeftHeader>
          <GridLeftBody>
            <VirtualList
              {...props.listProps}
              onScroll={onScroll}
              scrollTop={scrollTop}
              subtractHorizontalScrollbar
              fetching={props.fetching}
              width={props.listWidth}
            />
          </GridLeftBody>
          <GridLeftFooter
            style={{
              height: props.gridProps.headerHeight,
              bottom: scrollbarSize,
              width: props.listWidth,
            }}
          >
            <VirtualGrid
              scrollLeft={scrollLeft}
              {...props.gridProps}
              rowCount={1}
              columnCount={1}
              columnWidth={props.listWidth}
              cellRenderer={props.listProps.footerCellRenderer}
              width={props.listWidth}
              height={props.listProps.headerHeight}
              style={{
                overflow: 'hidden',
                borderTop: '1px solid #e1e1e1',
                background: '#fff',
              }}
            />
          </GridLeftFooter>
        </GridLeft>
        <GridRight>
          <GridRightHeader style={{ height: props.gridProps.headerHeight }}>
            <VirtualGrid
              {...props.gridProps}
              rowCount={1}
              height={props.gridProps.headerHeight}
              scrollLeft={scrollLeft}
              subtractVerticalScrollbar
              cellRenderer={props.gridProps.headerCellRenderer}
              style={{
                overflow: 'hidden',
                borderBottom: '1px solid #e1e1e1',
                background: '#fbfbfb',
              }}
            />
          </GridRightHeader>
          <GridRightBody>
            <VirtualGrid
              {...props.gridProps}
              minGrid
              onScroll={onScroll}
              scrollTop={scrollTop}
            />
          </GridRightBody>
          <GridRightFooter
            style={{
              height: props.gridProps.headerHeight,
              bottom: scrollbarSize,
              width: `calc(100% - ${props.listWidth}px)`,
            }}
          >
            <VirtualGrid
              {...props.gridProps}
              scrollLeft={scrollLeft}
              rowCount={1}
              subtractVerticalScrollbar
              cellRenderer={props.gridProps.footerCellRenderer}
              height={props.gridProps.headerHeight}
              style={{
                overflow: 'hidden',
                borderTop: '1px solid #e1e1e1',
                background: '#fbfbfb',
              }}
            />
          </GridRightFooter>
        </GridRight>
      </Grid>
    )}
  </ScrollSync>
);

const defaultSubProps = {
  headerHeight: 0,
  headerCellRenderer: null,
};

GridList.defaultProps = {
  listProps: defaultSubProps,
  gridProps: defaultSubProps,
  fetching: false,
};

export default GridList;
